import { z } from 'zod';

export const AccountMeetingLinkTypesSchema = z.object({
  zoom: z.boolean(),
  teams: z.boolean(),
});

export type AccountMeetingLinkTypes = z.infer<
  typeof AccountMeetingLinkTypesSchema
>;
